import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
// import Parser from 'rss-parser';
// import Parser from 'rss-parser/dist/rss-parser.min.js'
import PlayMedia from '~/core/components/PlayMedia';
import { fetchPodcastIfNeeded } from '../actions';
// import { fetchAndParsePodcast } from '~/features/actions';

// let parser = new Parser({
//   customFields: {
//     item: [ ['itunes:episodeType', 'episodeType'], ]
//   }
// });



const FromAToTripleZed = (props) =>
{

	const { dispatch, podcastFeed } = props
  useEffect( () => {
		props.dispatch(fetchPodcastIfNeeded())
  }, [])

  if  ( podcastFeed.feed.channel ) { 
    return (
    <div id="from-a-to-triple-zed" style={{ backgroundColor: 'black' }}>
      <div className="podcast" style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden'}}>
          { podcastFeed && podcastFeed.feed && podcastFeed.feed.channel.description &&
            <div className="feed">
              <div className="tile">
                <img className="podcast-tile" src={podcastFeed.feed.channel.image}  />
                <p>{podcastFeed.feed.channel.description}</p>
                <p>Subscribe on your favourite podcast app or via <a href="https://podfollow.com/1542143375" target="blank">this link</a></p>
              </div>
              <div className="episodes">
                {/* <h1>{podcastFeed.title}</h1> */}
                <div>
	                  { podcastFeed.feed.items.filter(i => i.itunes.season === "1").sort((a,b) => a.itunes.episode - b.itunes.episode).map( (item, n) =>
                    <div className="episode" key={n}>

                      <div className="episode-tile" style={{ backgroundImage: item['itunes:attributes'].image ? 'url(' + item['itunes:attributes'].image.href + ')' : 'url(' + podcastFeed.feed.channel.image + ')' }}>
                        <PlayMedia media={item.enclosure['@attributes'].url} title={item.title} />
                      </div>
                      <div style={{flex: 1}}>
                        <h3 className="episode-title">{item.title}</h3>
                        <p className="episode-subtitle">{item.itunes.subtitle}</p>
                        {/* <p>{item.itunes.episodeType}</p> */}
                        {/* <p>{item.itunes.season} / {item.itunes.episode}</p> */}
                        <div className="episode-notes" dangerouslySetInnerHTML={{ __html: item.content }}></div>
                      </div>
                    </div>
                  ) }
                  </div>
              </div>
            </div>
          }
      </div>
    </div>
  )
  }
  else {
    return null;
  }
}
export default connect(state => ({podcastFeed: state.podcastFeed})) (FromAToTripleZed)
